import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

import styles from "assets/jss/material-dashboard-pro-react/views/errorPageStyles.js";

const useStyles = makeStyles(styles);

export default function NewPage() {
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <GridContainer>
        <GridItem md={12}>
          <h1 className={classes.title}>Página</h1>
          <h2 className={classes.subTitle}>Em Construção</h2>
          <h4 className={classes.description}>
            Ooooups! Essa página ainda não foi finalizada.
          </h4>
        </GridItem>
      </GridContainer>
    </div>
  );
}
